import { FC, PropsWithChildren, useCallback, useEffect, useMemo, useRef } from 'react';

import AudioContext from './AudioContext';
import { useAudioManager } from './hooks';

const AudioProvider: FC<PropsWithChildren> = ({ children }) => {
  const actions = useAudioManager();

  // reset() unloads every Howl and empties the repository, so it must run on
  // real unmount only — hence the ref, which keeps the effect's dep array empty
  // and independent of the manager object's identity.
  const actionsRef = useRef(actions);
  actionsRef.current = actions;

  const resetOnUnmount = useCallback((): void => {
    actionsRef.current.reset();
  }, []);

  useEffect(() => resetOnUnmount, [resetOnUnmount]);

  const contextValue = useMemo(() => ({ ...actions }), [actions]);

  return <AudioContext.Provider value={contextValue}>{children}</AudioContext.Provider>;
};

export default AudioProvider;
